import './App.css';

import MyServicePage from './Page/Home';

function App() {
  return (
    <>
      <MyServicePage />
    </>
  );
}

export default App;
